import React from "react";
import {
  withStyles,
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Typography
} from "material-ui";
import PropTypes from "prop-types";

import profileCardStyle from "assets/jss/material-dashboard-react/profileCardStyle";

function ProfileCard({ ...props }) {
  const { classes, subtitle, title, description, footer, avatar } = props;

  return (
    <Card className={classes.card}>
      <CardHeader
        classes={{
          root: classes.cardHeader,
          avatar: classes.cardAvatar
        }}
        avatar={ avatar }
      />
      {/* <avatar/> */}
      <CardContent className={classes.textAlign}>
        {subtitle !== undefined ? (
          <Typography component="h6" className={classes.cardSubtitle}>
            {subtitle}
          </Typography>
        ) : null}
        {title !== undefined ? (
          <Typography component="h4" className={classes.cardTitle}>
            {title}
          </Typography>
        ) : null}
        {description !== undefined ? (
          <Typography component="div" className={classes.cardDescription}>
            {description}
          </Typography>
        ) : null}
      </CardContent>
      { footer !== undefined ?
      <CardActions className={classes.textAlign + " " + classes.cardActions}>
        {footer}
      </CardActions> : null
      }
    </Card>
  );
}

ProfileCard.propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.node,
  subtitle: PropTypes.node,
  description: PropTypes.node,
  footer: PropTypes.node,
  avatar: PropTypes.object.isRequired
};

export default withStyles(profileCardStyle)(ProfileCard);



// WEBPACK FOOTER //
// ./src/components/Cards/ProfileCard.jsx